import pb from "../api/pocketbase";
import { FileOptions } from "pocketbase";

const getFilesUrl = <T extends { [key: string]: any }>(
    records: T,
    fileName: string,
    options?: FileOptions
) => {
    const url = pb.files.getUrl(records, fileName, options);

    return url;
};

export { getFilesUrl };